export const alertNotificationsActionTypes = {
  currentStep: 'alertNotification/currentStep',
  search: 'alertNotification/search',
  currentSelected: 'alertNotification/currentSelected',
  readOnly: 'alertNotification/readOnly',
  tab: 'alertNotification/tab'
};
